import mixin from './../mixin';
import TableFilterable from './filterable';
import TableDeleteOneRowMixin from './delete_one_row_mixin';

class TableFilterableSingleDeletable extends TableFilterable {

  _initTableLinks() {
    super._initTableLinks();
    this._initTableRowsDeleteLinks();
  }

  _resetViewAfterTableRowDeletion() {
    this._resetStatusMessages();
  }
};

mixin(TableFilterableSingleDeletable, TableDeleteOneRowMixin);

export default TableFilterableSingleDeletable;


/** WEBPACK FOOTER **
 ** ./src/common/table/filterable_single_deletable.js
 **/